export default __webpack_public_path__ + "static/media/integration.d6d3d1e4.svg";